import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-gradient-to-r from-purple-600 via-purple-500 to-fuchsia-500 text-white hover:from-purple-700 hover:via-purple-600 hover:to-fuchsia-600 hover:shadow-lg hover:shadow-purple-500/25 shadow-md focus:ring-purple-500',
    secondary: 'bg-purple-900 text-white hover:bg-purple-800 hover:shadow-lg shadow-md focus:ring-purple-900',
    outline: 'border-2 border-purple-500 text-purple-600 hover:bg-purple-500 hover:text-white focus:ring-purple-500',
    ghost: 'text-gray-600 hover:text-purple-600 hover:bg-purple-50 focus:ring-purple-200'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className} ${isLoading ? 'opacity-80' : ''}`} disabled={disabled || isLoading} {...props} data-id="element-563">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-564" />}
      {children}
    </button>;
}